import type { TrackEventFn } from '@/analytics/hooks/useAnalytics'
import { AnalyticsEvent } from '@/analytics/schema/events.schema'

type ArtifactDownloadIdentity = {
  artifactVersionId: string
  artifactId?: string
}

function downloadIdentity(props: ArtifactDownloadIdentity) {
  return {
    artifactVersionId: props.artifactVersionId,
    ...(props.artifactId ? { artifactId: props.artifactId } : {}),
  }
}

export function trackArtifactDownloadSuccess(track: TrackEventFn, props: ArtifactDownloadIdentity) {
  track(AnalyticsEvent.ArtifactDownloadSuccess, downloadIdentity(props))
}

export function trackArtifactDownloadFailed(track: TrackEventFn, props: ArtifactDownloadIdentity) {
  track(AnalyticsEvent.ArtifactDownloadFailed, downloadIdentity(props))
}
